// extracted by mini-css-extract-plugin
export default {"menuItem":"UserItem_menuItem__+CUNh","menuItemText":"UserItem_menuItemText__EuvLW","menuItemTextActive":"UserItem_menuItemTextActive__I2+Yg","user":"UserItem_user__jeY3J"};